'use strict';

var SystemConfigurationPanelConfig = function SystemConfigurationPanelConfig($stateProvider) {
  $stateProvider.state('app.system-configuration', {
    url: '/workflow/system-configuration',
    params: {
      transitionData: null
    },
    views: {
      '': {
        template: require('../templates/system-configuration-panel.html'),
        controller: 'SystemConfigurationPanelController'
      },
      'mainToolbar': {
        template: require('../templates/system-configuration-toolbar.html'),
        controller: 'SystemConfigurationToolbarController'
      }
    }
  });
};
SystemConfigurationPanelConfig.$inject = ['$stateProvider'];
module.exports = SystemConfigurationPanelConfig;